import {CustomerRepReportContext} from '../../context'
import Search from '../../../../components/Search'
import {useContext, useState} from 'react'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import moment from 'moment'
import {SampleCSVDownload} from '../../../../components/SampleCSVDownload'
import Import from '../../../../images/Import.png'
import {MIN_DATE_RANGE, dataToSalesRepProfitCSV} from '../../utils'
import MultiSelect from '../../../../components/MultiSelect/MultiSelect'

const CustomerRepReportHeader = () => {
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')
  const {
    onSearch,
    onDateChange,
    reportData,
    salesRepTypes,
    isSalesRepDropdownLoading,
    onChangeSalesRepTypeFilter,
  } = useContext(CustomerRepReportContext)
  const [isLoading, setIsLoading] = useState(false)

  const handleDateChange = (startDate: any, endDate: any) => {
    onDateChange && onDateChange(startDate, endDate)
  }

  const handleDownLoadCSV = async () => {
    setIsLoading(true)
    const formattedDateTime = moment().format('D_MMM_HH_mm').toLowerCase()
    const data = dataToSalesRepProfitCSV(reportData)
    if (data?.length) {
      SampleCSVDownload(
        data || [],
        `Profitability_Sales_Representative_Report_${formattedDateTime}`
      )
    }
    setIsLoading(false)
  }

  return (
    <div className='d-flex flex-wrap justify-content-between align-items-end mb-10'>
      <div className='d-flex align-items-end gap-10'>
        <Search
          onSearch={(searchTerm: string) => {
            onSearch && onSearch(searchTerm)
          }}
        />
        <MultiSelect
          id={`sales-rep-filter`}
          label='Sales Rep Type'
          options={salesRepTypes}
          className='w-200px'
          placeholder='Select Sales Rep Type'
          allValuesSelectedText={'Sales Rep Type: All'}
          isLoading={isSalesRepDropdownLoading}
          handleSelected={onChangeSalesRepTypeFilter}
        />
      </div>
      <div className='d-flex gap-5'>
        <button
          className='btn btn-outline'
          onClick={handleDownLoadCSV}
          disabled={isLoading || !reportData?.length}
        >
          <div className='d-flex align-items-center'>
            <img src={Import} alt='Import File' className='me-2 import-icon' />
            <div className='d-flex align-items-center'>
              {isLoading ? 'Downloading...' : 'Export CSV'}
              {isLoading && (
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              )}
            </div>
          </div>
        </button>
        <div className='w-250px'>
          <PredefinedDateRange
            cb={handleDateChange}
            getLbl={() => {}}
            defaultValue={dateRangeLabel || 'Last 90 Days'}
            includeCurrantDay={true}
            startDate={MIN_DATE_RANGE}
          />
        </div>
      </div>
    </div>
  )
}

export default CustomerRepReportHeader
